import React from "react";

import Context from "../../../context/Context";
import DropdownButton from "../../common/Dropdown/DropdownButton";
import Icons from "../../util/Icons";
import Topic from "../../../context/Topic";

const CSS = {
  main: "i-header-user",
  userButton: "i-header-user-button"
};

export default class UserControl extends React.Component {

  constructor(props) {
    super(props);
    this.signinClicked = this.signinClicked.bind(this);
    this.signoutClicked = this.signoutClicked.bind(this);
  }

  configureClicked = () => {
    const uiMode = Context.instance.uiMode
    if (uiMode.isConfiguratorOn) return;
    setTimeout(() => {
      uiMode.toggleConfigurator(true);
      Topic.publish(Topic.ConfiguratorActivated,{});
    },10);
  }

  render() {
    const context = Context.getInstance();
    const i18n = context.i18n;
    const user = context.user;
    const hashref = "#";

    if (user.isAnonymous()) {
      return (
        <div className={CSS.main}>
          <a className={CSS.userButton} href={hashref} tabIndex="0"
            role="button" aria-label={i18n.user.signinTooltip}
            onClick={this.signinClicked}>
            <span>{i18n.user.signin}</span>
          </a>
        </div>
      );
    } else {
      const name = Context.getInstance().user.getDisplayName();
      const buttonContent = (
        <div key="i-user-dropdown" aria-label={i18n.user.menuTooltip}>
          <span className="esri-icon-user"></span>
          <span>{name}</span>
          <span>{Icons.dropdown()}</span>
        </div>
      );
      const dropdownContent = this.renderDropdownMenu();
      return (
        <div className={CSS.main}>
          <DropdownButton
            closeOnSelect={true}
            focusFirst={true}
            buttonClassName={"i-header-user-button"}
            buttonContent={buttonContent}
            dropdownContent={dropdownContent}
            placement="bottom-end">
          </DropdownButton>
        </div>
      );
    }
  }

  renderDropdownMenu() {
    const i18n = Context.instance.i18n;
    const hashref = "#";
    let isConfigureFirst = false;

    let configure = null;
    const canConfigure = Context.instance.user.canConfigureApp();
    if (canConfigure) {
      isConfigureFirst = true;
      configure = (
        <li key="configure" role="none">
          <a className="i-dd-menuitem" href={hashref} role="menuitem button" tabIndex="0"
            aria-label={i18n.configurator.buttonLabel}
            onClick={this.configureClicked}
            data-i--first={isConfigureFirst}
          >{i18n.configurator.buttonLabel}</a>
        </li>
      );
    }

    const menu = (
      <ul role="menu">
        {configure}
        <li key="signout" role="none">
          <a className="i-dd-menuitem" href={hashref} role="menuitem button" tabIndex="0"
            aria-label={i18n.user.signoutTooltip}
            onClick={this.signoutClicked}
            data-i--first={!isConfigureFirst}
          >{i18n.user.signout}</a>
        </li>
      </ul>
    );
    return menu;
  }

  signinClicked() {
    Topic.publish(Topic.SignInClicked,{});
  }

  signoutClicked() {
    Topic.publish(Topic.SignOutClicked,{});
  }

}
